export default "__VITE_ASSET__8c14ee7c__"